<template>
  <div class="wrapper">
    <template>
      <SuccessfulPurchase
        :installmentSelectedLabel="label"
        :paymentType="paymentType"
        :upsell="upsell"
      />
    </template>
  </div>
</template>

<script>
import SuccessfulPurchase from '@/views/Checkout/partials/SuccessfulPurchase/SuccessfulPurchase.vue'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'PaymentPixConfirmed',
  components: { SuccessfulPurchase },
  data: () => ({
    label: '',
    upsell: null,
    paymentType: 'pix',
  }),
  computed: {
    ...mapState('Checkout', {
      cart: (state) => state.cart,
    }),
  },
  mounted() {
    this.SET_CURRENT_STEP(-1)
    this.verifyPixPayment()
  },
  methods: {
    ...mapMutations('Checkout', ['SET_CURRENT_STEP']),
    ...mapActions('Checkout', ['checkPixPaid']),
    async verifyPixPayment() {
      if (!(await this.checkPixPaid(this.cart.order_id))) {
        await this.$router.push({ name: 'new.stepPayment' })
      }
    },
  },
}
</script>
